import React, { useCallback, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Card } from "reactstrap";

import { ChevronDown } from "react-feather";

import { AlertList, ProgressPage } from "components/Structure";
import { CustomDataTable } from "components/Structure/DataTable/customDataTable";

import {
  handleParamsNote,
  handleSetColumnsProducts,
  handleParamsPage,
} from "redux/taxAnalises";

import { getColumns } from "./columns";

import { TableListNotes } from "../Notes";

import DataTableMobile from "components/Structure/DataTable/MobileTable";
import { useArquivaMix } from "hooks";
import { useIsUserMix } from "hooks/useIsUserMix";

export const ListProducts = ({
  data,
  dataRes,
  isLoading,
  paramsSearch,
  revalidate,
}) => {
  const [currentRow, setCurrentRow] = useState(null);

  const { columnsProducts, tipo, params } = useSelector(
    state => state.taxAnalises,
  );

  const { isArquivaMix } = useArquivaMix();
  const isUserMix = useIsUserMix();

  const dispatch = useDispatch();

  const handlePageChange = useCallback(
    page => {
      dispatch(handleParamsNote({ field: "page", value: page }));
    },
    [dispatch],
  );

  const handlePageChangeProduct = useCallback(
    page => {
      dispatch(handleParamsPage({ page }));
    },
    [dispatch],
  );

  const handlePageByInput = page => dispatch(handleParamsPage({ page }));

  const handleChangeFilter = useCallback(
    (field, value) => {
      dispatch(handleParamsNote({ field, value }));
    },
    [dispatch],
  );


  useEffect(() => {
    if (tipo) {
      const columns = getColumns(revalidate, isUserMix);
      const items = (columns || []).filter(
        item => item?.isType === tipo || !item?.isType,
      );
      dispatch(handleSetColumnsProducts([...items]));
    }
  }, [tipo, dispatch, revalidate, isUserMix]);

  return (
    <>
      <Card className="p-0 d-none d-lg-block">
        <CustomDataTable
          className={isArquivaMix && "overflow-hidden"}
          pagination
          sortServer
          paginationServer
          responsive={true}
          progressPending={isLoading}
          columns={columnsProducts}
          data={(data || []).map((item, key) => ({
            ...item,
            key,
          }))}
          sortIcon={<ChevronDown />}
          defaultSortField="invoiceId"
          progressComponent={<ProgressPage />}
          noDataComponent={
            <AlertList title="Sem dados para listagem" description="" />
          }
          page={params?.page}
          totalPages={dataRes?.max_pages}
          expandableRows
          expandableRowExpanded={row => row === currentRow}
          expandOnRowClicked
          onRowClicked={row => setCurrentRow(row)}
          onRowExpandToggled={(bool, row) => {
            setCurrentRow(row);
            dispatch(handleParamsNote({ field: "page", value: 1 }));
          }}
          handlePageChange={handlePageChangeProduct}
          expandableRowsComponent={data => {
            return (
              <TableListNotes
                data={data}
                paramsSearch={paramsSearch}
                handlePageChange={handlePageChange}
                handleChangeFilter={handleChangeFilter}
              />
            );
          }}
          inputPagination
          handleInputPagination={handlePageByInput}
        />
      </Card>
      <DataTableMobile
        columns={columnsProducts}
        data={data || []}
        page={params?.page}
        totalDocs={data?.length}
        totalPages={dataRes?.max_pages}
        isLoading={isLoading}
        expandableRows
        titleAdding="Notas Fiscais"
        childrenExpendade={TableListNotes}
      />
    </>
  );
};
